'use client'
import PropTypes from "prop-types";
import { useContext, useEffect, useState } from "react";

// material-ui
import { useTheme } from "@mui/material/styles";
import {
  Button,
  CardContent,
  Checkbox,
  Collapse,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Stack,
  Tooltip,
  Typography,
  useMediaQuery
} from "@mui/material";

// third-party
import PerfectScrollbar from "react-perfect-scrollbar";
import ReactMarkdown from "react-markdown";
// import ReactQuill from 'react-quill';
// import 'react-quill/dist/quill.snow.css';

// project imports
import useConfig from "@/app/hooks/useConfig";
import MainCard from "@/app/ui-component/cards/MainCard";
import Avatar from "@/app/ui-component/extended/Avatar";
import AttachmentCard from "@/app/ui-component/cards/AttachmentCard";
import SubCard from "@/app/ui-component/cards/SubCard";
import { gridSpacing } from "@/app/store/constant";

// assets
import AttachmentTwoToneIcon from "@mui/icons-material/AttachmentTwoTone";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import NewReleasesTwoToneIcon from "@mui/icons-material/NewReleasesTwoTone";
import StarBorderTwoToneIcon from "@mui/icons-material/StarBorderTwoTone";
import StarTwoToneIcon from "@mui/icons-material/StarTwoTone";
import LabelTwoToneIcon from "@mui/icons-material/LabelTwoTone";
import KeyboardArrowLeftTwoToneIcon from "@mui/icons-material/KeyboardArrowLeftTwoTone";
import MoreHorizTwoToneIcon from "@mui/icons-material/MoreHorizTwoTone";
import ReplyTwoToneIcon from "@mui/icons-material/ReplyTwoTone";
import ForwardTwoToneIcon from "@mui/icons-material/ForwardTwoTone";
import { useSelector } from "@/app/store";
import { useIntl } from "react-intl";

import {
  getAllNotificacao,
  notificacaoCountNaoLida,
  notificacaoGravarDados,
  getSucess,
} from "@/app/store/slices/notificacaoUsuarios2";
import { dispatch } from "@/app/store";
import { Form, useForm } from "@/app/reusableComponents/useForm";
import rehypeRaw from "rehype-raw";
import { openSnackbar } from "@/app/store/slices/snackbar";
import { updateNotificacaoLida } from "@/app/services/admin/NotificacoesUsuario.services";
import ReactQuill from "react-quill";
import { getBaseURL } from "@/app/global-functions/baseURLUtils-administrators";
import MailList from "./MailList";
import { useRouter, useSearchParams } from 'next/navigation';

import CloseIcon from "@mui/icons-material/Close";

const initialFValues = {
  id: 0,
  titulo: "",
  mensagem: "",
  data: null,
  hora: null,
  lida: 1,
  group_beneficiaire: "",
  universityID: null,
  facultyID: null,
  departmentID: null,
  academicYearID: null,
  coursID: null,
  userAdminEnvoiID: null,
  userEtudiantRecoitID: null,
  typeMessage: 0,
  reponse_message: 1,
  studentID: null,
  notificacoesUsuarios_mainID: null,
  uerAdminRecoitID: null,
};
// ==============================|| MAIL DETAILS ||============================== //

const NotificationRead = (props) => {
  const theme = useTheme();
  const { fontFamily } = useConfig();
  const matchDownSM = useMediaQuery(theme.breakpoints.down("md"));
  const [anchorEl, setAnchorEl] = useState(null);
  //  const { notificacaoOneUser, totalNaoLida, notificacaoSuccess } = useSelector(
  //   (state) => state.notificacaoUsuarios2
  // );
  const intl = useIntl();

  const {
    dadosparams,
    closeReadComponent
  } = props;


  // const { id, sedeID } = notificacaoOneUser;
   const [paramTable, setParamTable] = useState([{}]);
  const location = useRouter();
  const navigate = useRouter();
  const router = useRouter();

  const [markdown, setMarkdown] = useState("");
  const [userID, setUserID] = useState("");
  const { paramMemoire } = useSelector((state) => state.diversParametersRedux);

   const [messageRecuEnvoye, setMessageRecuEnvoye] = useState("");  // recu = 2 , envoye = 1 
  
   const searchParams = useSearchParams();

   const [mensagem, setmensagem] = useState("");  // recu = 2 , envoye = 1 

   const [userFirstName, setuserFirstName] = useState("");  // recu = 2 , envoye = 1 
   const [userlastname, setuserlastname] = useState("");  // recu = 2 , envoye = 1 

   const [photofilename, setphotofilename] = useState(getBaseURL());  // backend URL

  const [url, setUrl] = useState(getBaseURL());  // backend URL

  const [main, setMain] = useState("");  // backend URL
  const [imageSrc, setImageSrc] = useState("");
  const [openImage, setOpenImage] = useState(false);

  // const { id, messageRecuEnvoye, paramTable, handleDrawerOpen } = router.query;

  const validate = (fieldValues = values) => {
    let validationErrorM = {};

    // if ("titulo" in fieldValues)
    //   validationErrorM.titulo = fieldValues.titulo ? "" : " "; // This field is Required

    if ("mensagem" in fieldValues)
      validationErrorM.mensagem = fieldValues.mensagem ? "" : " ";

    setErrors({
      ...validationErrorM,
    });

    return Object.values(validationErrorM).every((x) => x === ""); // it will return true if x==""
  };

  const { values, setValues, errors, setErrors, handleInputChange } = useForm(
    initialFValues,
    true,
    validate
  ); // use

  const getTime = () => {
    var today = new Date(),
      time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    values.hora = time;
    let today2 = new Date().toLocaleDateString();
    values.data = today2;
  };
  useEffect(() => {

    window.scrollTo(0, 0); // open the page on top
    // Assuming searchParams is already defined to access query parameters
   //  console.log(searchParams.get('id'));  // Logs the 'id' query parameter
   //  console.log(searchParams.get('messageRecuEnvoye'));  // Logs 'messageRecuEnvoye'
 //    console.log(searchParams.get('paramTable'));  // Logs 'paramTable'
    
    if (dadosparams) {
      // Parse the paramTable string to an object
  
      // Now you can access properties of the parsed object
     //  console.log("Group Beneficiaire: ", paramTableObject.group_beneficiaire);  // Logs group_beneficiaire
   //    console.log("First Name: ", paramTableObject.firstname);  // Logs firstname
    //   console.log("Message: ", paramTableObject.mensagem);  // Logs mensagem
  
      // Set the state with the parsed object
      setParamTable(dadosparams.row);
      setMain(dadosparams.row.mainID);
      setmensagem(dadosparams.row.mensagem);


      setuserFirstName(dadosparams.row.userFirstName);
      setuserlastname(dadosparams.row.userlastname);
      setphotofilename(dadosparams.row.photofilename);


       // Set other state values
    // console.log("userFirstName: ", paramTableObject.userFirstName);  // Logs mensagem
    // console.log("userlastname: ", paramTableObject.userlastname)  // Logs mensagem

    setMessageRecuEnvoye(dadosparams.row.messageRecuEnvoye);

    }
  
   
  }, []);


  /* useEffect(() => {
    getTime();
    paramMemoire.map(async(item) => {
    setUserID(item.id);
    })
    if (router.isReady) {
      // Access query parameters when router is ready
      const { id, messageRecuEnvoye, paramTable, handleDrawerOpen } = router.query;

      // Log the query params for debugging
      console.log("router.query ########", router.query);

      if (id && paramTable) {
        // Parse paramTable if it's a stringified object
        const parsedParamTable = JSON.parse(paramTable);

        // Set the states with the received data
        setParamTable(parsedParamTable);
        setMessageRecuEnvoye(messageRecuEnvoye);
        setData({
          id,
          messageRecuEnvoye,
          paramTable: parsedParamTable,
          handleDrawerOpen
        });
      }
    }
  }, [router.isReady, router.query]);  // Trigger when router is ready or query params change
 */

  // useEffect( () => {
   /*  getTime();
      paramMemoire.map(async(item) => {
      setUserID(item.id);
      console.log("router.query ########", router.query);

      if (router.isReady) { // Wait until the router is fully loaded
        const { id, messageRecuEnvoye, paramTable, handleDrawerOpen } = router.query;
  
        console.log("router.query ########", router.query);

        // Safely use the query parameters
        if (id && paramTable) {
          setParamTable(paramTable);
          setMessageRecuEnvoye(messageRecuEnvoye);
          setData({
            id,
            messageRecuEnvoye,
            paramTable: JSON.parse(paramTable), // Parse JSON if necessary
            handleDrawerOpen
          });
        }
      } */

     //  console.log("ocation.state ", location.state)
   //    if (id && messageRecuEnvoye) {
       // setParamTable(location.state.paramTable);
    //    setMarkdown(paramTable.mensagem);

      //  setMessageRecuEnvoye(location.state.messageRecuEnvoye);

      //  if(Number(messageRecuEnvoye) === 2) {

          /*
          updateNotificacaoLida(id, data);
          dispatch(
            notificacaoCountNaoLida(
              "non-lu-administratif",
              location.state.paramTable.universityID,
              item.id
            )

            
          );
          */
      
  
       

      /*   dispatch(
          notificacaoCountNaoLida(
            "non-lu-administratif",
            location.state.paramTable.universityID,
            item.id
          )
        ); */
        
      
   //  });

   
 // }, [paramTable, markdown, userID, messageRecuEnvoye]);
// }, [router.isReady, router.query]);

  const handleClickSort = (event) => {
    setAnchorEl(event?.currentTarget);
  };
  const handleCloseSort = () => {
    setAnchorEl(null);
  };

  const [openQuill, setOpenQuill] = useState(true);
  const handleChangeQuill = () => {
    setOpenQuill(true);
  };

  const handleBack = () => {
    closeReadComponent(main);
  };

  const notificacaoGravar = (e) => {
    e.preventDefault();

    getTime(); // envoyer la date et l'heure

    values.titulo = "RE: " + paramTable.titulo;
    values.lida = 1;
    values.group_beneficiaire = paramTable.group_beneficiaire;
    values.universityID = paramTable.universityID;
    values.facultyID = paramTable.facultyID;
    values.departmentID = paramTable.departmentID;
    values.academicYearID = paramTable.academicYearID;
    values.coursID = paramTable.coursID;
    values.userAdminEnvoiID = userID;
    values.userEtudiantRecoitID = paramTable.userEtudiantRecoitID;
    values.studentID = paramTable.studentID;
    values.notificacoesUsuarios_mainID = paramTable.notificacoesUsuarios_mainID;
    values.uerAdminRecoitID = paramTable.userAdminEnvoiID;

    dispatch(notificacaoGravarDados(values));

    dispatch(
      openSnackbar({
        open: true,
        message: intl.formatMessage({ id: "mensagem_Gravar_Nova_Agencia" }),
        anchorOrigin: { vertical: "top", horizontal: "right" },
        variant: "alert",
        alert: {
          color: "success",
        },
        close: false,
      })
    );
  };

  const handleClickOpenImage = (imageSrc) => {
    setImageSrc(imageSrc);
    setOpenImage(true);
  };

  const handleCloseImage = () => {
    setOpenImage(false);
  };

  return (
    <Form onSubmit={notificacaoGravar}>
       <PerfectScrollbar
          style={{ height: "auto" }}
          // style={{ height: "calc(100vh)" }}
        >
      <MainCard
        sx={{
          bgcolor:
            theme.palette.mode === "dark"
              ? theme.palette.dark.main
              : theme.palette.grey[50],
        }}
        content={false}
      >
        <CardContent>
          
          <Grid container spacing={gridSpacing}>
            <Grid item xs={12}>
              <Grid
                container
                alignItems="center"
                justifyContent="space-between"
                spacing={matchDownSM ? 1 : 0}
              >
                <Grid item>
                  <Stack
                    direction="row"
                    alignItems="center"
                    spacing={matchDownSM ? 1 : 2}
                  >
                    <Tooltip
                      arrow
                      placement="top"
                      title={intl.formatMessage({ id: "Retourner" })}
                    >
                      <Button color="primary" 
                      onClick={handleBack} size="small">
                        <KeyboardArrowLeftTwoToneIcon />
                      </Button>
                    </Tooltip>

                    <Avatar
                      alt="image"
                      onClick={() => handleClickOpenImage(
                        photofilename !== ""
                        ? url + `/studentMatriculas/images?tipoDisplay=${photofilename}`
                        : url + "/studentMatriculas/images?tipoDisplay=semfoto.png"

                          )}
                      src={
                        Number(paramTable.group_beneficiaire) < 6
                          ? 
                            photofilename !== ""
                            ? url + `/studentMatriculas/images?tipoDisplay=${photofilename}`
                            : url + "/studentMatriculas/images?tipoDisplay=semfoto.png"

                          : Number(paramTable.group_beneficiaire) > 6?

                          Number(messageRecuEnvoye) === 2 ? // message recu = 2
                         
                          photofilename !== ""
                          ? url+ `/users/images?tipoDisplay=${photofilename}`
                          : url + "/users/images?tipoDisplay=semfoto.png"
                          : 
                          paramTable.notificacoesUerAdminRecoit &&
                            photofilename !== ""
                            ? url + `/users/images?tipoDisplay=${photofilename}`
                            : url + "/users/images?tipoDisplay=semfoto.png"
                          : null
                      }
                      
                      size={matchDownSM ? "xs" : "sm"}
                    />
                    <Grid container alignItems="center">

                      <Grid item xs={12}>
                        <Stack
                          direction={matchDownSM ? "column" : "row"}
                          alignItems={matchDownSM ? "flex-start" : "center"}
                          spacing={matchDownSM ? 0 : 1}
                        >
                          <Typography variant={matchDownSM ? "h5" : "h4"}>
                      {Number(paramTable.group_beneficiaire) < 6
                        ? 
                          paramTable.firstname &&
                          paramTable.lastname
                          ? `${paramTable.firstname} ${paramTable.lastname}`
                          : "No student information available"
                        : Number(paramTable.group_beneficiaire) > 6
                        ? 
                          paramTable.firstname &&
                          paramTable.lastname
                          ? `${paramTable.firstname} ${paramTable.lastname}`
                          : "No admin information available"
                        : null}
                          </Typography>
                          <Typography sx={{ display: { xs: "block", sm: "none" } }} variant="subtitle2">
                            {Number(paramTable.group_beneficiaire) < 6
                              ? 
                                paramTable.firstname &&
                                paramTable.lastname
                                ? `${paramTable.firstname} ${paramTable.lastname}`
                                : "No student information available"
                              : Number(paramTable.group_beneficiaire) > 6
                              ?
                                paramTable.firstname &&
                                paramTable.lastname
                                ? `${paramTable.firstname} ${paramTable.lastname}`
                                : "No user information available"
                              : null}
                              </Typography>

                        </Stack>
                      </Grid>
                      <Grid item sx={{ display: { xs: "none", sm: "block" } }}>
                        <Typography variant="subtitle2">
                          {Number(paramTable.group_beneficiaire) < 6
                            ? paramTable.email
                            : null}{" "}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sx={{ display: { xs: "block", sm: "block" } }}>
                        <Typography variant="subtitle2" style={{color: "red", fontWeight:600}}>
                        {intl.formatMessage({ id: "expeditor" })} : {(userFirstName +  " " + userlastname) }
                        </Typography>
                      </Grid>
                    </Grid>
                  </Stack>
                </Grid>
                <Grid item>
                  <Typography variant="subtitle2">
                    {paramTable.data} {paramTable.hora}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
       
          <CardContent sx={{ pt: 0 }}>
            <Grid container spacing={gridSpacing}>
              <Grid item xs={12}>
                <Grid container spacing={gridSpacing}>
                  <Grid item xs={12}>
                    <Grid container alignItems="center" spacing={0}>
                      <Grid item>
                        <Typography variant={matchDownSM ? "h4" : "h3"}>
                        {intl.formatMessage({ id: "titulo" })}
                         : {paramTable.titulo}
                        </Typography>
                      </Grid>
                      <Grid item xs zeroMinWidth />
                     
                    </Grid>
                  </Grid>

                  {/* {data?.attachments && ( */}
                    {/* <Grid item xs={12}>
                      <Grid container spacing={gridSpacing}>
                        <Grid item xs={12}>
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                          >
                            <AttachmentTwoToneIcon fontSize="small" />
                            <Typography variant="h5">
                              {data?.attachments.length}{" "}
                            </Typography>
                            <Typography variant="h5">{intl.formatMessage({ id: "attache_um_fichier" })}</Typography>
                          </Stack>
                        </Grid>
                        {data?.attachments.map((item, index) => (
                          <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                            <AttachmentCard
                              image={item.image}
                              title={item.title}
                            />
                          </Grid>
                        ))}
                      </Grid>
                    </Grid> */}
                  {/* )} */}
                  {/* {messageRecuEnvoye ===1 ? */}
                 {/*  <Grid item xs={12}>
                    <Grid container spacing={1} alignItems="center">
                      <Grid item>
                        <Button
                          variant="outlined"
                          startIcon={<ReplyTwoToneIcon />}
                          onClick={handleChangeQuill}
                        >
                          {intl.formatMessage({ id: "responder" })}
                        </Button>
                      </Grid>
                      <Grid item>
                        <Button
                          variant="outlined"
                          startIcon={<ForwardTwoToneIcon />}
                          onClick={handleChangeQuill}
                        >
                          {intl.formatMessage({ id: "encamimhar" })}
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid> */}
                  {/* :null} */}
                  <Grid  item xs={12}
                    sx={{
                      "& > p": {
                        ...theme.typography.body1,
                        marginBottom: 0,
                      },
                    }}
                  >
                   <Collapse
  in={openQuill}
  sx={{ width: "100%", height: "650px" }}
>
  {openQuill && (
    <Grid item xs={12} sx={{ p: 3 }}>
      <SubCard
        sx={{
          bgcolor:
            theme.palette.mode === "dark"
              ? theme.palette.dark.dark
              : theme.palette.primary[200] + 40,
          "& .quill": {
            bgcolor:
              theme.palette.mode === "dark"
                ? theme.palette.dark.main
                : theme.palette.grey[50],
            borderRadius: "12px",
            "& .ql-toolbar": {
              display: "none", // Hide toolbar
            },
            "& .ql-container": {
              fontFamily,
              fontSize: "0.875rem",
              borderColor:
                theme.palette.mode === "dark"
                  ? `${theme.palette.dark.light + 20} !important`
                  : theme.palette.primary.light,
              borderBottomLeftRadius: "12px",
              borderBottomRightRadius: "12px",
              "& .ql-editor": {
                height: 450,
              },
            },
          },
        }}
      >
        <ReactQuill
          value={mensagem} // Display the formatted message
          readOnly={true}  // Set the editor to read-only
          modules={{ toolbar: false }}  // Disable the toolbar
          theme="bubble"  // Optional: use a lighter theme
        />

        {/* Other components such as buttons or icons */}
        <Grid
          container
          spacing={1}
          alignItems="center"
          sx={{ mt: 2 }}
        >
          <Grid item>
            <IconButton size="large">
              <UploadFileIcon />
            </IconButton>
          </Grid>
          <Grid item>
            <IconButton size="large">
              <AttachmentTwoToneIcon />
            </IconButton>
          </Grid>
          <Grid item sx={{ flexGrow: 1 }} />
          <Grid item>
            <Button
              onClick={() => handleBack()}
              sx={{ color: theme.palette.grey[900] }}
            >
              {intl.formatMessage({ id: "cancelar" })}
            </Button>
          </Grid>
          <Grid item>
            <Button variant="contained" type="submit">
              {intl.formatMessage({ id: "responder" })}
            </Button>
          </Grid>
        </Grid>
      </SubCard>
    </Grid>
  )}
</Collapse>


                  </Grid>
                </Grid>
              </Grid>
              <Dialog open={openImage} 
              onClose={handleCloseImage}
               maxWidth="md">
        <DialogContent>
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleCloseImage}
            aria-label="close"
            style={{
              position: 'absolute',
              top: 8,
              right: 8,
              zIndex: 1
            }}
          >
            <CloseIcon />
          </IconButton>
          <img
            src={imageSrc}
            alt="User"
            style={{ width: '100%', height: 'auto', display: 'block' }}
          />
        </DialogContent>
      </Dialog>
            </Grid>
          </CardContent>
      </MainCard>
      </PerfectScrollbar>
     
    
    </Form>
    
  );
};

NotificationRead.propTypes = {
  data: PropTypes.object,
  handleUserDetails: PropTypes.func,
  handleStarredChange: PropTypes.func,
  handleImportantChange: PropTypes.func,
};

export default NotificationRead;
